import ReactDOM from 'react-dom';
import preloaded from '../src/preloaded.js';
import VideoVitalsFilterForm from '../src/filterVideoVitals/VideoVitalsFilterForm.js';

let e = document.getElementById('app');
if (e) {
  ReactDOM.render(
    <VideoVitalsFilterForm
      actionUrl={preloaded.action_url}
      initialFilters={preloaded.filters}
      allGradYears={preloaded.all_grad_years}
      allSports={preloaded.all_sports}
      allPositions={preloaded.all_positions}/>
  , e);
}
